export default __webpack_public_path__ + "static/media/galaxy.797d6999.svg";